export const UPDATE_SOLUTION_REQUEST = "UPDATE_SOLUTION_REQUEST";
export const UPDATE_SOLUTION_SUCCESS = "UPDATE_SOLUTION_SUCCESS";
export const UPDATE_SOLUTION_FAIL = "UPDATE_SOLUTION_FAIL";
export const RESET_UPDATE_SOLUTION_ERROR = "RESET_UPDATE_SOLUTION_ERROR";
